import {StyleSheet} from 'react-native';

import {darkGray, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  notesContainer: {
    marginHorizontal: 20,
  },
  dateText: {
    color: darkGray,
    fontSize: 14,
  },
  textInputContainer: {
    maxHeight: 300,
    marginBottom: 20,
  },
  notesCount: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
    color: darkGray,
  },
});
